export function initializeTemplateWithMetadata(
    templateData: any,
    metadata: {
        pnoLogo: string;
        companyName: string;
        companyAddress: string;
        currentDate: string;
        entityType?: string;
        userName?: string;
        userDesignation?: string;
        userEmail?: string;
    },
) {
    const {
        pnoLogo,
        companyName,
        companyAddress,
        currentDate,
        entityType = '',
        userName = '',
        userDesignation = '',
        userEmail = '',
    } = metadata;

    // Recursively replace "text" key values in the templateData object
    const replaceTextInTemplateData = (data: any) => {
        if (Array.isArray(data)) {
            return data.map((item) => replaceTextInTemplateData(item));
        } else if (typeof data === 'object' && data !== null) {
            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => {
                    if (['text', 'url', 'link'].includes(key) && typeof value === 'string') {
                        return [
                            key,
                            value
                                .replace(/{{pnoLogo}}/g, pnoLogo)
                                .replace(/{{companyName}}/g, companyName)
                                .replace(/{{companyAddress}}/g, companyAddress)
                                .replace(/{{entityType}}/g, entityType)
                                .replace(/{{userName}}/g, userName)
                                .replace(/{{userDesignation}}/g, userDesignation)
                                .replace(/{{userEmail}}/g, userEmail)
                                .replace(/{{date}}/g, currentDate),
                        ];
                    }
                    return [key, replaceTextInTemplateData(value)];
                }),
            );
        }
        return data;
    };

    const convertLinksInTemplateData = (data: any): any => {
        if (Array.isArray(data)) {
            return data.map((item) => convertLinksInTemplateData(item));
        } else if (typeof data === 'object' && data !== null) {
            if (data.type === 'link') return data;
            if (Array.isArray(data.children)) {
                const processedChildren: any[] = [];
                let i = 0;

                while (i < data.children.length) {
                    const child = data.children[i];

                    if (
                        child &&
                        typeof child === 'object' &&
                        !child.type &&
                        'text' in child &&
                        'link' in child &&
                        typeof child.link === 'string'
                    ) {
                        const textNode: any = { text: child.text };
                        Object.keys(child).forEach((key) => {
                            if (key !== 'text' && key !== 'link' && typeof child[key] !== 'object') {
                                textNode[key] = child[key];
                            }
                        });

                        processedChildren.push({
                            type: 'link',
                            href: child.link,
                            target: '_blank',
                            children: [textNode],
                        });
                        i++;
                    } else {
                        processedChildren.push(convertLinksInTemplateData(child));
                        i++;
                    }
                }

                return {
                    ...data,
                    children: processedChildren,
                };
            }

            return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, convertLinksInTemplateData(value)]));
        }
        return data;
    };

    // Create a deep copy of the templateData to avoid mutating the original object
    const templateDataCopy = JSON.parse(JSON.stringify(templateData));

    // Replace text in the copied templateData
    const updatedTemplateData = replaceTextInTemplateData(templateDataCopy);

    // Convert text nodes with link properties to proper link elements
    const finalTemplateData = convertLinksInTemplateData(updatedTemplateData);

    // Return the updated templateData
    return finalTemplateData;
}
